(function () {
  'use strict';

  const ZENDESK_API = "Pt4kNwlxmG8NsJ3dSmD09TVxOecBF8fBcJRrPqBj";
  const ZENDESK_EMAIL = "heather.s@jaques.co.uk";
  btoa(`${ZENDESK_EMAIL}/token:${ZENDESK_API}`);

  const submitTicket = async (data) => {
    let subject = $( "#enquiry_type option:selected" ).text(),
        enquiry_type = $( "#enquiry_type" ).val(),
        comment = $('#message').val(),
        order_number = $('#order_number').val(),
        tracking_number = $('#tracking_number').val(),
        phone_number = $('#phone').val(),
        reason_for_return = $('#reason_for_return').val(),
        name = $('#name').val(),
        email = $('#email').val(),
        form_subject = `Contact Form: ${subject}`;

    if(order_number != '') {
      form_subject = `Contact Form: ${subject} - ${order_number}`;
    }

    // Create the ticket data
    const ticketData = {
      "request": {
        "ticket_form_id": 9627457397394,
        "subject": form_subject,
        "comment": { 
          "body": comment,
          "uploads": [] // Will be populated if there's a file
        },
        "priority": "normal",
        "status": "new",
        "custom_fields": [
          { "id": 9627517684882, "value": order_number }, // Order Number
          { "id": 360019888080, "value": enquiry_type }, // Enquiry Type
          { "id": 4413390549778, "value": reason_for_return }, // Return Reason Select
          { "id": 9631999558546, "value": tracking_number }, // Tracking Number   
          { "id": 9632337905298, "value": phone_number }, // Phone Number      
        ],
        "requester": { 
          "name": name,
          "email": email
        }
      }
    };

    try {
      // If there's a file, upload it first
      const fileInput = document.getElementById('attachment');
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        
        // Validate file type
        const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
        if (!validTypes.includes(file.type)) {
          throw new Error('Invalid file type. Please upload a JPG, PNG, or GIF image.');
        }

        // Validate file size (5MB max)
        if (file.size > 5 * 1024 * 1024) {
          throw new Error('File size too large. Maximum size is 5MB.');
        }

        const uploadData = new FormData();
        uploadData.append('file', file);

        // Upload the file first
        const uploadResponse = await fetch("https://jaqueslondon.zendesk.com/api/v2/uploads.json?filename=" + encodeURIComponent(file.name), {
          method: "POST",
          headers: {
            "Authorization": "Basic " + btoa("heather.s@jaques.co.uk:Pt4kNwlxmG8NsJ3dSmD09TVxOecBF8fBcJRrPqBj"),
            "Content-Type": file.type // Set the correct content type for the image
          },
          body: file // Send the file directly instead of using FormData
        });

        if (!uploadResponse.ok) {
          const errorData = await uploadResponse.json();
          throw new Error(errorData.error || 'File upload failed');
        }

        const uploadResult = await uploadResponse.json();
        ticketData.request.comment.uploads = [uploadResult.upload.token];
      }

      // Create the ticket
      const response = await fetch("https://jaqueslondon.zendesk.com/api/v2/requests.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Basic " + btoa("heather.s@jaques.co.uk:Pt4kNwlxmG8NsJ3dSmD09TVxOecBF8fBcJRrPqBj")
        },
        body: JSON.stringify(ticketData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create ticket');
      }

      const data = await response.json();
      $('#zd-enquiry-msg').html('<div class="alert alert-success">Thank you for your enquiry. We will be in touch shortly.</div>');
      $('#zd-enquiry').remove();
    } catch (error) {
      console.error('Error:', error);
      $('#zd-enquiry-msg').html(`<div class="alert alert-error">${error.message || 'Sorry, there seems to be an issue with your enquiry. Please email <a href="mailto:gameon@jaqueslondon.co.uk">gameon@jaqueslondon.co.uk</a> and we will be able to assist you further.'}</div>`);
    }
  };

  // $('#submit-ticket').on('click', function() {
  //   console.log('submitting ticket')
  //   submitTicket()
  // });

  $('#zd-enquiry').on('change', '#enquiry_type', function() {
    let enquiry_type = $(this).val();
    $('#zd-enquiry').attr('data-type', enquiry_type);
    //order_enquiries, order_cancellation, missing_faulty_items, export_enquiries, delivery_enquiries, appraisals, other, return_enquiries
    //remove required from all fields
    $('.order-fields input, .return-fields select').prop('required',false);
    if(enquiry_type == 'order_enquiries' || enquiry_type == 'order_cancellation' || enquiry_type == 'missing_faulty_items' || enquiry_type == 'delivery_enquiries' || enquiry_type == 'return_enquiries') {
      //console.log(enquiry_type);
      $('.order-fields input').prop('required',true);
    }
    if(enquiry_type == 'return_enquiries') {
      $('.return-fields select').prop('required',true);
    }
  });

  const form = document.getElementById("zd-enquiry");
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      let isValid = true;
      const inputs = form.elements;
      for (let i = 0; i < inputs.length; i++) {
        if (!inputs[i].checkValidity()) {
          isValid = false;
          break;
        }
      }
      if (isValid) {
        // form is valid, do something
        submitTicket();
      } else {
        // form is not valid, display error messages
        alert('form is not valid');
      }
    });

})();
